import moment from 'moment';
import { useMemo } from 'react';
import type { Onboarding, OnboardingSubject } from './onboardingSlice';
import { OnboardingActions } from './onboardingSlice';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';

interface OnboardingData {
  onboarding?: Onboarding;
  onComplete: () => void;
  onReset: () => void;
  onSkip: () => void;
  onUpdateStep: (step: number) => void;
}

const useOnboardingData: (subject: OnboardingSubject) => OnboardingData = (
  subject,
) => {
  const dispatch = useAppDispatch();
  const localOnboarding = useAppSelector(
    (state) => state.onboarding.data[subject],
  );

  const data = useMemo(() => {
    const now = moment().toISOString();
    const update = (localUpdates: Partial<Onboarding>) => {
      dispatch(
        OnboardingActions.setOnboardingData({
          ...(localOnboarding || { subject, step: 0 }),
          ...localUpdates,
        }),
      );
    };

    return {
      onboarding: localOnboarding,
      onComplete: () => update({ completedAt: now }),
      onReset: () => update({ completedAt: null, skippedAt: null, step: 0 }),
      onSkip: () => update({ skippedAt: now }),
      onUpdateStep: (step: number) => update({ step }),
    };
  }, [dispatch, localOnboarding, subject]);

  return data;
};

export default useOnboardingData;
